import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CheckInList = ({ checkIns }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-success/10 text-success';
      case 'expiring':
        return 'bg-warning/10 text-warning';
      case 'expired':
        return 'bg-error/10 text-error';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date?.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground">Recent Check-Ins</h2>
        <button className="text-sm text-primary hover:text-primary/80 transition-colors">
          View All
        </button>
      </div>
      <div className="space-y-4">
        {checkIns?.map((checkIn) => (
          <div 
            key={checkIn?.id}
            className="flex items-center gap-4 p-4 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors"
          >
            <div className="relative">
              <Image
                src={checkIn?.avatar}
                alt={checkIn?.avatarAlt}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-success rounded-full border-2 border-card flex items-center justify-center">
                <Icon name="Check" size={12} color="white" />
              </div>
            </div>

            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <h3 className="text-sm font-semibold text-foreground truncate">
                  {checkIn?.name}
                </h3>
                <span className={`text-xs px-2 py-0.5 rounded-full ${getStatusColor(checkIn?.membershipStatus)}`}>
                  {checkIn?.membershipStatus}
                </span>
              </div>
              <div className="flex items-center gap-3 text-xs text-muted-foreground">
                <span className="flex items-center gap-1">
                  <Icon name="Clock" size={12} />
                  {formatTime(checkIn?.timestamp)}
                </span>
                <span className="flex items-center gap-1">
                  <Icon name="MapPin" size={12} />
                  {checkIn?.location}
                </span>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <button className="p-2 rounded-lg hover:bg-muted transition-colors focus-ring">
                <Icon name="User" size={18} color="var(--color-primary)" />
              </button>
              <button className="p-2 rounded-lg hover:bg-muted transition-colors focus-ring">
                <Icon name="MoreVertical" size={18} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CheckInList;